import { ForwardedRef, MutableRefObject } from 'react';

export const useUnifiedRef = <T>(
  forwardedRef: ForwardedRef<T>,
  internalRef: MutableRefObject<T | null>
) => {
  const unifiedRef = !forwardedRef
    ? internalRef
    : forwardedRef instanceof Function
    ? (tableInstance: T) => {
        internalRef.current = tableInstance;
        forwardedRef(tableInstance);
      }
    : forwardedRef;

  return {
    ref: unifiedRef,
    get current(): T | null {
      return unifiedRef instanceof Function
        ? internalRef.current
        : unifiedRef.current;
    },
  };
};
